import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styles: []
})
export class ManualComponent implements OnInit {
  rol: number = 0;     
  constructor() {
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {      
      this.rol = u.rol;
    }
  }

  ngOnInit() {
  }

}
